import React, { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Check, ChevronDown } from "lucide-react";
import { useLocation } from "react-router-dom";

const dropdownVariants = {
  hidden: { opacity: 0, y: -10, scale: 0.95 },
  visible: { opacity: 1, y: 0, scale: 1 },
  exit: { opacity: 0, y: -10, scale: 0.95 },
};

const SelectController = ({ label, options, value, onChange, name, disabled, error }) => {

  const { pathname } = useLocation()
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  const selectedOption = options.find((opt) => opt.value === value);

  const handleOptionClick = (option) => {
    onChange({ target: { name, value: option.value } });
    setIsOpen(false);
  };

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="flex flex-col relative w-full" ref={wrapperRef}>
      {label && (
        <label className={`mb-1 
  ${pathname === "/signup" ? "text-red-900 font-semibold" :
            pathname === "/all-profiles" ? "text-black font-bold text-lg font-sans" :
              "text-white font-bold text-lg font-sans"} 
  text-sm`}>
          {label}
        </label>
      )}

      <button
        type="button"
        onClick={() => !disabled && setIsOpen(prev => !prev)}
        disabled={disabled}
        className={`flex justify-between items-center p-3 
          ${pathname !== "/signup" ? "bg-[#fff6e2]" : ""} 
          ${error ? "border-red-500" : pathname !== "/signup" ? "border-gray-300" : "border-red-300"} 
          border rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-400 transition-all duration-300 text-sm`}
      >
        <span className="" style={{fontFamily:"sans-serif"}}>{selectedOption?.label || label || "Select..."}</span>
        <ChevronDown className={`w-4 h-4 transition-transform ${isOpen ? "rotate-180" : ""}`} />
      </button>

      {error && <div className="text-red-500 text-sm mt-1">{error}</div>}

      <AnimatePresence>
        {isOpen && (
          <motion.ul
            variants={dropdownVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            transition={{ duration: 0.15 }}
            className={`absolute top-full z-50 mt-1 w-full border 
              ${pathname !== "/signup" ? "bg-[#fff6e2]" : "bg-white"} border-gray-200 rounded-lg shadow-md max-h-80 overflow-y-auto`}
          >
            {options.map((option) => (
              <li
                key={option.value}
                onClick={() => handleOptionClick(option)}
                className={`px-4 py-2 text-sm font-sans cursor-pointer ${pathname !== "/signup" ? "hover:bg-[#f5ebd3]" : "hover:bg-gray-300"}  transition-all duration-300 
                  flex justify-between items-center ${option.value === value ?
                    `${pathname !== "/signup" ? "bg-[#f5ebd3]" : "bg-gray-100"} font-medium` : ""
                  }`}
              >
                <span>{option.label}</span>
                {option.value === value && value !== "" && (
                  <Check className="w-4 h-4 ml-2" />
                )}
              </li>
            ))}
          </motion.ul>
        )}
      </AnimatePresence>
    </div>
  );
};

export default SelectController;